import React from 'react';
import { Row, Col, Card, Descriptions, Form, Input, Button } from 'antd';
import { Footer } from "antd/es/layout/layout";
import { Image, Flex } from "antd";
import backarrow from "../assets/images/icon/back-arrow.svg";
import easebuzzlogo from "../assets/images/easebuzzlogo.svg";
import { validateAmount } from "../helperFunctions";
import "./index.css";
import HeaderCustomerDetails from '../common/Layouts/AppLayout/HeaderCustomerDetails';
const CustomerDetails = ({ 
  isMobile, 
  backButtonClick, 
  customerData, 
  payBillForm, 
  callPayBillAPI, 
  screenWidth, 
  minimum_accept_amount_for_payment 
}) => (
    <div className="background-image-internal">
    
    <div className='' style={{display:"flex"}}>
      <Row>
        {!isMobile ? (
          <div className="backbtn">
            <span
              style={{ color: "#2A2A2A" }}  
              className="back-btn"
              onClick={() => backButtonClick()}
            >
              <Image style={{ padding: "5px" }} src={backarrow} alt="" preview={false} />
              Back
            </span>
          </div>
        ) : null}
      </Row>
      <HeaderCustomerDetails />
    </div>
    <Row className="cust-details-m">
      <Col className="cust-m" xs={22} sm={18} md={16} lg={12} xl={10} xxl={9}>
        <div className="card-third">
          <Card className="custom-card" bordered={false}>
            <Descriptions
              column={1}
              labelStyle={{  width: "50%" }}
              contentStyle={{  textAlign: "left" }}
            >
              <Flex>
                <p className="cust-head">
                  <img className='cust-table-logo' style={{ marginRight: "10px" }} src={customerData?.customer_details?.icon} alt="icon" />
                  {customerData?.customer_details?.heading}
                </p>
              </Flex>
              {(customerData?.customer_details?.information || []).map((item) => (
                <Descriptions.Item label={item.label} key={item.key}>
                  {item.value}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </Card>
          
          {customerData?.amount_details.information.length > 0 && (
            <Card className="custom-card" bordered={false}>
              <div className="desktop-amount">
                <Descriptions
                  column={1}
                  labelStyle={{  width: "170px", display: "unset" }}
                  contentStyle={{  fontWeight: "700" }}
                >
                  <Flex>
                    <p className="cust-head">
                      <img className='cust-table-logo' style={{ marginRight: "10px" }} src={customerData?.amount_details?.icon} alt="amount icon" />
                      {customerData?.amount_details?.heading}
                    </p>
                  </Flex>
                  {(customerData?.amount_details?.information || []).map((item) => (
                    <Descriptions.Item label={item.label} key={item.key}>
                      {item.prefix} {item.value}
                    </Descriptions.Item>
                  ))}
                </Descriptions>
              </div>
              <div className="mobile-amount">
                <Descriptions
                  column={1}
                  labelStyle={{  width: "170px", display: "unset" }}
                  contentStyle={{  fontWeight: "700" }}
                >
                  <Flex>
                    <p className="cust-head">
                      <img className='cust-table-logo' style={{ marginRight: "10px" }} src={customerData?.amount_details?.icon} alt="amount icon" />
                      {customerData?.amount_details?.heading}
                    </p>
                  </Flex>
                  {(customerData?.amount_details?.information || []).map((item) => (
                    <Descriptions.Item label={item.label} key={item.key}>
                      {item.prefix} {item.value}
                    </Descriptions.Item>
                  ))}
                </Descriptions>
              </div>
            </Card>
          )}
          
          {customerData?.additional_details.information.length > 0 && (
            <Card className="custom-card" bordered={false}>
              <Descriptions
                column={1}
                labelStyle={{  width: "170px" }}
                contentStyle={{  }}
              >
                <Flex>
                  <p className="cust-head">
                    <img className='cust-table-logo' style={{ marginRight: "10px" }} src={customerData?.additional_details?.icon} />
                    {customerData?.additional_details?.heading}
                  </p>
                </Flex>
                {(customerData?.additional_details?.information || []).map((item) => (
                  <Descriptions.Item label={item.label} key={item.key}>
                    {item.value}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Card>
          )}
          
        </div>
      </Col>
      <Col className="" xs={24} sm={18} md={16} lg={12} xl={7} xxl={6}>
        <div className="card-second">
          <Card className="amount-card">
            <Form
              className="payable-amount-mob"
              form={payBillForm}
              name="payBillForm"
              onFinish={callPayBillAPI}
              autoComplete="off"
              layout={screenWidth > 620 ? "inline" : "horizontal"}
            >
              
              <p className="cust-head customer-amount-mob">Payable Amount</p>
              
              <Row gutter={16} className="pay-col">
                <Col xxl={{ span: 18 }} xl={{ span: 17 }} lg={{ span: 22 }} md={{ span: 19 }} sm={{ span: 20 }} xs={{ span: 16 }}>
                  <Form.Item
                    name="amount"
                    rules={[{ validator: validateAmount(minimum_accept_amount_for_payment) }]}
                    style={{ fontWeight: "100", marginInlineEnd:"0" }}
                  >
                    <Input size="large" type="number" placeholder="Enter Amount..." prefix="₹" />
                  </Form.Item>
                </Col>
                <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 2 }} md={{ span: 2 }} sm={{ span: 2 }} xs={{ span: 4 }}>
                  <Button size="large" style={{ fontFamily: "DM Sans" }} className="pay" htmlType="submit">
                    Pay Now
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card>
        </div>
        {!isMobile ? (
          <Footer className="custom-footer customer-details-pwrdbyeasebuzz">
            <Image width={200} src={easebuzzlogo} alt="" preview={false} />
          </Footer>
        ) : null}
      </Col>
    </Row>
  </div>
);
export default CustomerDetails;